<template>
<BootstrapDialog title="监控记录详情" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row" style="border-bottom: 1px solid gray">
		        <div class="col-sm-5 col-sm-offset-1">
		            <div class="form-group">
		                <label class="col-sm-4 control-label" style="height: 200px;line-height: 200px;font-weight: bolder">准考证照片:</label>
		                <div class="col-sm-8">
		                    <img :src="detail.xcpz" alt="准考证照片" style="height: 200px;">
		                </div>
		            </div>
		        </div>
		        <div class="col-sm-5 ">
		            <div class="form-group">
		                <label class="col-sm-4 control-label" style="height: 200px;line-height: 200px;font-weight: bolder">抓拍照片:</label>
		                <div class="col-sm-8">
		                    <img :src="detail.bizZypxKjrlbd.url" alt="抓拍照片" style="height: 200px;">
		                </div>
		            </div>
		        </div>
		    </div>
		    <div class="row" style="margin-top: 30px">
		        <label class="col-sm-4 control-label" style="font-weight: bolder">比对置信度:</label>
		        <p class="col-sm-2">{{ detail.bizZypxKjrlbd.bdzxd }}</p>
		        <p style="color: #666666">*范围[0~100]，比对置信度值越大，则判断为同一人几率越大</p>
		    </div>
		    <div class="row" style="margin-top: 30px">
		        <label class="col-sm-4 control-label" style="font-weight: bolder">是否通过:</label>
		        <p class="col-sm-4">{{ detail.bizZypxKjrlbd.sftg === '1' ? '通过' : '不通过' }}</p>
		    </div>
		    <div class="row" style="margin-top: 30px">
		        <label class="col-sm-4 control-label" style="font-weight: bolder">记录时间:</label>
		        <p class="col-sm-4">{{ detail.bizZypxKjrlbd.jlsj }}</p>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
		<button class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 课件监控-比对详情
     */
    export default {
        name: "CourseLearnMonitorJiankong",
        components:{
		},
        data: function () {
            return {
                detail: {
                  xcpz: '',
                  bizZypxKjrlbd: {}
                }
            }
        },
		methods:{
			reset:function(){
				this.detail = {
				  xcpz: '',
				  bizZypxKjrlbd: {}
				}
			},
			async open(params){
				let res =await this.$http.post('/htgl/biz/zypx/kjxx/kjjk/jkxq', params);
				if(res.data){
					 this.detail = res.data
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			}
		}
    }
</script>
<style scoped>


</style>